<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<a name="top"></a>
<main [ngCommonBusy]="loadLanguagesBusy">
    <central-login-app-header [currentUser]="currentUser" *ngIf="module == 'central-login' && (page == 'dashboard' || page == 'account-settings')"></central-login-app-header>
    <router-outlet *ngIf="languagesInitialized"></router-outlet>
</main>
